export enum UpmEntityType {
  Plant = 'Plant',
  Area = 'Area',
  ProductionLine = 'ProductionLine',
  Department = 'Department',
  Equipment = 'Equipment'
}
